import { render, staticRenderFns } from "./CurrencySelector.yaml?vue&type=template&id=4abb844c&component"
import script from "./CurrencySelector.yaml?vue&type=script&lang=ts&component"
export * from "./CurrencySelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports